export default __webpack_public_path__ + "static/media/Meghan_9781408356647.e25a037d.jpg";